import { createRoute } from "@tanstack/react-router";

import { requirePermission } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { ApiKeysPage } from "./api-keys.page";

export const apiKeysRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/api-keys",
	beforeLoad: ({ context }) => requirePermission(context.queryClient, { apiKey: ["read"] }),
	component: ApiKeysPage,
});
